import { requestFromServer } from "./api-client";

const Driver = {
	getDriverByCNH: async (cnh) => 
		 requestFromServer(`v1/Drivers/getByDocument/${cnh}`)
	
};

export default Driver;
